import { network } from 'services/network';

export const getRelatedActivity = (params) => {
    const url = `api/bo/getRelatedActivity?taskId=${params.taskId}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
